import React from "react";

export const Home = () => <div>Домашняя страница</div>;
